jQuery.fn.selectText = function () {
    var doc = document;
    var element = this[0];
    var range, selection;
    // console.log(this, element);
    if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    }
};

// modal functions
// include the close modal functions
function closeModal() {
    $('.overlay, .modal').removeClass('visible');
}

$('body').click(function(e){
    if($(e.target).attr('class') === 'overlay visible') {
        closeModal();
    }
});

$(document).keyup(function(e) {
    if (e.keyCode === 27) { // Esc
        closeModal();
    }
});

$(document).keyup(function(e) {
    if (e.keyCode ===13) { // Esc
        if($('.modal.display-notice').hasClass('visible')) {
            $('.modal a.close-notice').trigger('click');
            // closeModal();
            e.preventDefault();
            return false;
        }
    }
});


$('body').on('click', '.modal a.close', function() {
    closeModal();        
    return false;
});

$('body').on('click', '.ignore', function() {
    return false;
});

// add the filled class to the labels
$('body').on('focus', '.fields li input, .fields li textarea', function () {
    var $this = $(this);
    $this.keyup(function () {
        if ($this.val() !== '') {
            $this.parent('li').addClass('filled');
        } else {
            $this.parent('li').removeClass('filled');
        }
    });
});

$('body').on('keyup blur', '.input input', function () {
    var $this = $(this);
    if ($this.val() !== '') {
        $this.parent('.input').addClass('filled');
    } else {
        $this.parent('.input').removeClass('filled');
    }
});

$('body').on('blur', '.fields li input, .fields li textarea', function () {
    var $this = $(this);
    if ($this.val() !== '') {
        $this.parent('li').addClass('filled');
    } else {
        $this.parent('li').removeClass('filled');
    }
});

function showNotice(header, message, button = 'Close') {
    var scrollTop = $(window).scrollTop();
    $('.display-notice').css({
        'top': (scrollTop - 500) + 'px'
    });

    $('.display-notice h6').html(header);
    $('.display-notice .notice-message').html(message);
    $('.display-notice .button').html(button);
    $('.overlay, .modal.display-notice').addClass('visible');
}

function openModal(modal, offset = 500) {

    var scrollTop = $(window).scrollTop();
    $(modal).css({
        'top': (scrollTop - offset) + 'px'
    });

    setTimeout(function () {
        $(modal).addClass('visible');
        $(modal).find('.fields li input, .fields li textarea').each(function () {
            var $this = $(this);
            if ($this.val() !== '') {
                $this.parent('li').addClass('filled');
            } else {
                $this.parent('li').removeClass('filled');
            }
        });
    }, 100);

    $('.overlay').addClass('visible');
}


$('body').click(function (e) {
    if ($(e.target).attr('class') === 'overlay visible') {
        closeModal();
    }
});

$(document).keyup(function (e) {
    if (e.keyCode === 27) { // Esc
        closeModal();
    }
});

$('body').on('click', '.modal a.close', function () {
    closeModal();
    return false;
});

$('body').on('click', '.modal a.close-notice', function () {
    if ($('.modal.visible').length === 1) {
        $('.display-notice, .overlay').removeClass('visible');
    } else {
        $('.display-notice').removeClass('visible');
    }

    return false;
});

// function loading(text = 'Loading...') {
//     $('.loading-overlay, .loading').addClass('visible');
//     $('.loading span').html(text);
// }

// function unloading() {
//     $('.loading-overlay, .loading').removeClass('visible');
// }

// $('body').on('click', '.loading .hide-loading', function () {
//     unloading();
//     return false;
// });

$('.mask').each(function () {
    var $this = $(this);
    $this.mask($this.attr('data-mask'), {
        placeholder: $this.attr('data-placeholder')
    });
});